export const primary = {
  190: '#000B1A',
  175: '#001B40',
  150: '#003580',
  125: '#0050BF',
  100: '#006AFF',
  75: '#3f8cfd',
  50: '#80B5FF',
  25: '#BFDAFF',
  15: '#deedff',
  10: '#E5F0FF',
  5: '#ecf7ff',
  2: '#f2faff',
};

export type PrimaryVariants = keyof typeof primary;
